export const en = {
    'minutes': 'minutes',
};
